/**
 * The custom hook for accessing previous state/prop
 * https://usehooks.com/usePrevious/
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Yucho Ho
 */
import { useEffect, useRef } from 'react'

const usePrevious = (value) => {
  const ref = useRef()

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}

export default usePrevious
